import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";

interface Profile {
  
  userId?:any
  file?:File
  // Add other fields as needed
}

// Set default values
const defaultProfile: Profile = {
  
  // Add default values for other fields as needed
};


// Hook to manage tenants data
export function useProfile() {
  const queryClient = useQueryClient();

  // GET all tenants
  const Profile = (userId:any) =>
    useQuery({
      queryKey: ["profile"],
      queryFn: async () => {
        try {
          console.log("User profile ID", userId);
          const response = await axios.get(`/api/v1/profile-picture/${userId}`);
          return response.data as ApiResponse;
        } catch (error:any) {
            toast.error('Error fetching profile')
          console.error("Error fetching tenants:", error);
          // throw error;
        }
      },
      staleTime: 300000,
    });

    const addProfile = useMutation({
        mutationFn: async (newTenant: Profile) => {
          try {
            const profileData: Profile = { ...defaultProfile, ...newTenant };
            const formData = new FormData();
      
            Object.keys(profileData).forEach((key) => {
              const value = profileData[key as keyof Profile];
              if (value !== undefined) {
                if (value instanceof File) {
                  formData.append(key, value);
                } else {
                  formData.append(key, value.toString());
                }
              }
            });
      
            // Send formData with Axios
            const response = await axios.post(`/api/v1/profile-update`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
      
            return response.data; // Return the response data if needed
          } catch (error: any) {
            throw error
            // toast.error(error)
            // Rethrow the error to trigger onError
            // throw new Error(
            //   error.response?.data?.message || error.message || "An error occurred"
            // );
          }
        },
        onError: (error) => {
          toast.error(
            error.message
              ? `${error.message}`
              : "Sorry, Failed to add Tenant, please try again"
          );
        },
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ["profile"] });
          toast.success("User has successfully added a tenant...");
        },
      });
      

 


 
 

  return {
    Profile,
    queryClient,
    addProfile,
   
  };
}
